import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file
 * @author dailin01
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from 'react';
import OutlinedDown from "acud-icon/es/icons/OutlinedDown";
import classNames from 'classnames';
import DropdownButton from './dropdown-button';
import { RcDropdown } from './rc-dropdown';
import { tuple } from '../_util/type';
import { cloneElement } from '../_util/reactNode';
import { ConfigContext } from '../config-provider';
import Select from '../select';
import Cascader from '../cascader';
var PlacementTypes = tuple('bottomLeft', 'bottomCenter', 'bottomRight', 'topLeft', 'topCenter', 'topRight', 'rightTop', 'rightCenter', 'rightBottom');

var Dropdown = function Dropdown(props) {
  var _classNames, _classNames2;

  var label = props.label,
      image = props.image,
      labelIcon = props.labelIcon,
      customizePrefixCls = props.prefixCls,
      disabled = props.disabled,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      direction = props.direction,
      visible = props.visible,
      children = props.children,
      getPopupContainer = props.getPopupContainer,
      rest = __rest(props, ["label", "image", "labelIcon", "prefixCls", "disabled", "trigger", "direction", "visible", "children", "getPopupContainer"]);

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      getCxtPopupContainer = _React$useContext.getPopupContainer;

  var triggerActions = disabled ? [] : trigger; // 菜单可见，需要将ICON旋转

  var _useState = useState(!!visible),
      _useState2 = _slicedToArray(_useState, 2),
      popupVisible = _useState2[0],
      setPopupVisible = _useState2[1];

  var mergedVisible = 'visible' in props ? visible : popupVisible;
  var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
  var arrowCls = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-trigger-arrow"), true), _defineProperty(_classNames, "".concat(prefixCls, "-trigger-arrow-expand"), mergedVisible), _classNames));
  var titleCls = classNames((_classNames2 = {}, _defineProperty(_classNames2, 'trigger-title', true), _defineProperty(_classNames2, 'trigger-title-withicon', labelIcon), _classNames2));
  var child = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-trigger")
  }, children ? children : /*#__PURE__*/React.createElement(React.Fragment, null, image && typeof image === 'string' ? /*#__PURE__*/React.createElement("img", {
    src: image
  }) : image, /*#__PURE__*/React.createElement("span", {
    className: titleCls,
    "aria-disabled": disabled
  }, label), labelIcon && /*#__PURE__*/React.createElement(OutlinedDown, {
    className: arrowCls
  })));
  var dropdownTrigger = cloneElement(child, {
    className: classNames(child.props.className, _defineProperty({}, "".concat(prefixCls, "-trigger-disabled"), disabled)),
    disabled: disabled
  });

  var onVisibleChange = function onVisibleChange(visible) {
    var onVisibleChange = props.onVisibleChange;
    setPopupVisible(visible);

    if (typeof onVisibleChange === 'function') {
      onVisibleChange(visible);
    }
  };

  var renderOverlay = function renderOverlay() {
    var overlay = props.overlay;
    var overlayNode;

    if (typeof overlay === 'function') {
      overlayNode = overlay();
    } else {
      overlayNode = overlay;
    }

    overlayNode = React.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/React.createElement("span", null, overlayNode) : overlayNode);
    var overlayProps = overlayNode.props; // menu cannot be selectable in dropdown defaultly
    // menu should be focusable in dropdown defaultly

    var _overlayProps$selecta = overlayProps.selectable,
        selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
        _overlayProps$focusab = overlayProps.focusable,
        focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
    var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlayNode : cloneElement(overlayNode, {
      mode: 'vertical',
      selectable: selectable,
      focusable: focusable
    });
    return fixedModeOverlay;
  };

  return /*#__PURE__*/React.createElement(RcDropdown, _extends({}, rest, {
    prefixCls: prefixCls,
    trigger: triggerActions,
    onVisibleChange: onVisibleChange,
    visible: mergedVisible,
    overlay: function overlay() {
      return renderOverlay();
    },
    getPopupContainer: getPopupContainer || getCxtPopupContainer
  }), dropdownTrigger);
};

Dropdown.Button = DropdownButton;
Dropdown.Select = Select;
Dropdown.Cascader = Cascader;
export default Dropdown;